export default "<div class=\"panel__refresh medium-spinner active-spinner\">\n  <span class=\"spin-circle\"></span>\n</div>"